import { ReactElement } from 'react';

export default function ProgressBar({ progress }: { progress: number }): ReactElement<any> | null {
  return (
    <div className="w-full bg-white/[14%] rounded-full h-1">
      <div className="bg-white h-1 rounded-full" style={{ width: `${progress}%` }}></div>
    </div>
  );
}
